import { ReactNode } from "react";

import { FormLabel } from "../FormLabel";

interface TwoFieldsProps {
  title?: string;
  titleClasses?: string;
  subTitle?: string;
  subTitleClasses?: string;
  classes?: string;
  children: ReactNode;
}

export function TwoFields({ title, titleClasses, subTitle, subTitleClasses, classes, children }: TwoFieldsProps) {
  return (
    <article className={classes}>
      <div className="mb-2">
        {title ? (
          <FormLabel htmlFor="" className={titleClasses} id={title}>
            {title}
          </FormLabel>
        ) : null}
        {subTitle ? <p className={`text-sm font-light text-gray-600 ${subTitleClasses}`}>{subTitle}</p> : null}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">{children}</div>
    </article>
  );
}
